<div class="maintenance-container">
  <div class="row">
    <div class="col-12 text-center">
      <p class="maintenance-message mt-5" v-html="$t('error.label_maint_run_maintenance')"></p>
      <p class="maintenance-date mt-4" v-html="msg"></p>
      <p class="mt-4 mb-0" v-html="$t('error.label_maint_under_maintenance')"></p>
      <p class="mb-0" v-html="$t('error.label_maint_guide_mirror_site')"></p>
      <p class="mb-0" v-html="$t('error.label_maint_refer_to_manual')"></p>
      <p class="mt-4" v-html="$t('error.label_maint_close')"></p>
      <p class="mt-4">
        <a :href="siteUrl" @click="isCloudFront && $event.preventDefault()">{{ $t('error.label_maint_go_mirror_site_URL') }}</a>
      </p>
    </div>
  </div>
</div>